import React, { useEffect, useState } from 'react';
// import { useQuery, QueryClientProvider } from 'react-query';
// import { FixedSizeGrid } from 'react-window';
// import TextField from '@mui/material/TextField';
// import ListItem from '@mui/material/ListItem';
// import { queryClient } from '../../utils/queryClient';
import {
  AppBar, Box, ListItemButton, ListSubheader,
  // Paper, InputBase, IconButton,
  Typography, ListItemText, List, Link
} from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
import { getRandomStr } from '../../helpers';
import { useRouter } from 'next/router';

const getAlphabets = () => {
  const alphabets = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));
  // return ['All', ...alphabets];
  return alphabets;
};

// const filterStocksByAlphabet = (stocks, selectedAlphabet) => {
//   if (selectedAlphabet === 'All') {
//     return stocks;
//   }
//   return stocks.filter((stock) => stock.t.startsWith(selectedAlphabet));
// };

// const filterStocksBySearch = (stocks, searchQuery) => {
//   if (!searchQuery) {
//     return stocks;
//   }
//   const query = searchQuery.toLowerCase();
//   // return stocks.filter((stock) => stock.t.toLowerCase().includes(query) || stock.n1.toLowerCase().includes(query));
//   return stocks.filter((stock) => stock.n1.toLowerCase().includes(query));
// };

const StockList = ({ stockData, sortedSections }) => {
  const router = useRouter();
  const { query } = router;
  const { alphabet } = query;

  // if (!stockData || !Array.isArray(stockData) || stockData.length === 0) {
  //   console.error('Invalid or empty data:');
  //   return <div>No valid data available.</div>;
  // }
  // const [selectedAlphabet, setSelectedAlphabet] = useState(alphabet || 'A');
  // const [searchQuery, setSearchQuery] = useState('');
  // // const { data: filteredStocks } = useQuery(['stocks', selectedAlphabet, searchQuery], () => {
  // //   let result = filterStocksByAlphabet(stockData, selectedAlphabet);
  // //   result = filterStocksBySearch(result, searchQuery);
  // //   return result;
  // // });

  // useEffect(() => {
  //   setSelectedAlphabet(alphabet || 'A');
  // }, [alphabet]);

  useEffect(() => {
    if (!alphabet || !/^[a-zA-Z]$/.test(alphabet)) {
      router.push(`/browse/stocks/a`);
    }
  }, []);

  // const filteredStocks = React.useMemo(() => {
  //   let result = filterStocksByAlphabet(stockData, selectedAlphabet);
  //   result = filterStocksBySearch(result, searchQuery);
  //   return result;
  // }, [stockData, selectedAlphabet, searchQuery]);

  // let groupedAndSorted;

  // try {
  //   groupedAndSorted = filteredStocks?.reduce((acc, item) => {
  //     let key;

  //     if (item && item.n1) {
  //       const firstChar = item.n1.charAt(0).toUpperCase();
  //       key = isNaN(firstChar) ? firstChar : '#'; // Check if it's a number
  //     } else {
  //       key = '#'; // Default to '#' if n1 is undefined or null
  //     }

  //     acc[key] = acc[key] || [];
  //     acc[key].push(item);
  //     return acc;
  //   }, {});

  //   for (const key in groupedAndSorted) {
  //     if (groupedAndSorted.hasOwnProperty(key)) {
  //       if (key === '#') {
  //         groupedAndSorted[key].sort((a, b) => a.n1.localeCompare(b.n1));
  //       } else {
  //         groupedAndSorted[key].sort((a, b) => a.n1.localeCompare(b.n1));
  //       }
  //     }
  //   }
  // } catch (error) {
  //   console.error('Error during grouping and sorting:', error);
  //   return <div style={{ textAlign: 'center', padding: '12rem 0' }}>Error occurred while processing data.<br />Please reload the page.</div>;
  // }

  // if (!groupedAndSorted) {
  //   console.error('Grouped and sorted data is undefined.');
  //   return <div style={{ textAlign: 'center', padding: '12rem 0' }}>Error occurred while sorting data.<br />Please reload the page.</div>;
  // }

  // const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
  //   if (a === '#') return -1; // '#' section should come first
  //   if (b === '#') return 1;
  //   return a.localeCompare(b); // Sort other sections alphabetically
  // });

  const alphabets = getAlphabets();

  const handleAlphabetClick = (alphabet) => {
    // setSelectedAlphabet(alphabet);
    router.push(`/browse/stocks/${alphabet.toLowerCase()}`);
  };

  // const handleSearchChange = (event) => {
  //   setSearchQuery(event.target.value);
  // };

  // // const renderStockItem = ({ columnIndex, rowIndex, style }) => {
  // //   const index = rowIndex * 4 + columnIndex;
  // //   const stock = filteredStocks[index];

  // //   if (!stock) {
  // //     return null;
  // //   }

  // //   return (
  // //     <ListItemButton dense={true} component="a" href={`/stock/${stock.t}`} key={stock.t} style={style}> {/* onClick={() => handleListItemClick(stock.t)}> */}
  // //       <ListItemText primary={stock.t} secondary={stock.n1} sx={{ my: '0 !important' }} />
  // //     </ListItemButton>);
  // // };

  return (
    <>
      <AppBar position="static" id="search-stocks" sx={{ bgcolor: '#fff', }} elevation={0}>
        <Box sx={{ mt: 3, mx: 'auto', padding: '8px 8px 8px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
          <Typography color="#1d1d1f" variant="h1" sx={{ fontWeight: 500, fontSize: '1.4rem', lineHeight: 1, letterSpacing: '0.0075em', textTransform: 'capitalize' }}>
            Browse Stocks
          </Typography>
          {alphabet &&
            <Typography variant="p" sx={{ mx: 0, fontWeight: 500, fontSize: '.9rem', color: 'rgb(96, 111, 123)', mt: 2 }}>
              {`The following list comprises companies and tickers that begin with the letter - ${alphabet?.toUpperCase()}`}
            </Typography>}
          {/* <Paper
            component="form"
            sx={{
              p: '2px 4px', display: 'flex', alignItems: 'center', width: 400,
              boxShadow: 0, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.12)', borderRadius: '8px',
            }}
          >
            <InputBase
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{ mx: 1.5, flex: 1, pb: 0, lineHeight: 1, }}
              placeholder="Search Grufity Stocks"
              inputProps={{ 'aria-label': 'search google maps' }}
            />
            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper> */}
        </Box>
      </AppBar>
      <Box component="div" sx={{ display: 'flex', justifyContent: 'center', mx: { md: '60px', sm: '12px', xs: "12px" }, my: '60px', flexWrap: 'wrap' }}>
        {alphabets.map((a) => (
          <Typography
            key={getRandomStr(3)}
            variant="button"
            sx={{
              cursor: 'pointer', color: a.toLowerCase() === alphabet ? '#fff' : '#6e6e73', border: '1px solid', borderColor: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              fontWeight: a.toLowerCase() === alphabet ? 600 : 500, background: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              px: 1, py: .2, borderRadius: '8px', mr: 1,
              '&:hover': { borderColor: 'rgba(0, 0, 0, 0.12)' }
            }}
            onClick={() => handleAlphabetClick(a)}
          // href={`/browse/stocks/${a.toLowerCase()}`}
          >
            {a}
          </Typography>
        ))}
      </Box>
      {/* <List dense={true}>
        <FixedSizeGrid
          columnCount={4}
          columnWidth={300}
          rowCount={Math.ceil(filteredStocks?.length / 4)}
          rowHeight={60}
          width={4 * 300}
          height={1200}
        >
          {renderStockItem}
        </FixedSizeGrid>

      </List> */}
      <List subheader={<li />}
        dense={true}
        sx={{
          '-webkit-column-count': { md: 4, sm: 2, xs: 1 },
          '-moz-column-count': { md: 4, sm: 2, xs: 1 },
          columnCount: { md: 4, sm: 2, xs: 1 },
          '-webkit-column-width': '4em',
          '-moz-column-width': '4em',
          columnWidth: '4em',
          '& .MuiListItemText-primary': { color: 'rgb(0 0 0 / 70%)', textTransform: 'capitalize' },
          '& a:hover .MuiListItemText-primary': { color: '#174ea6', },
          '& .MuiListItemText-primary .li-ticker': {
            color: 'rgb(0 0 0 / 70%)',
            fontWeight: 600, fontSize: '.8rem',
            display: 'none',
          },
          '& a:hover .li-ticker': { display: 'inline', ml: 'auto' }, mb: 17, '& ul': { p: '0 !important' }
        }}
      >
        {sortedSections?.map((alphabet) => (
          <li key={getRandomStr(7)} style={{ listStyle: 'none', margin: "0 0 1.5rem 0", display: 'block' }}>
            <ul>
              <ListSubheader sx={{ background: "transparent", fontWeight: 600, color: '#6e6e73', lineHeight: '24px', mb: 1.2 }}>{alphabet}</ListSubheader>
              {stockData[alphabet]?.map((item) => (
                <ListItemButton
                  target="_blank" rel="noopener noreferrer" component="a"
                  href={`/stock/${item.t}`} key={item.t} dense={true}
                  sx={{ '& .MuiListItemText-dense': { my: 0 }, borderRadius: '8px', }}
                >
                  {/* <ListItemText primary={<>{item.n1}<span className="li-ticker">, {item.t}</span></>} /> */}
                  <ListItemText primary={item.n1} />
                </ListItemButton>
              ))}
            </ul>
          </li>
        ))}
      </List>
      <Box component="div" sx={{ display: 'flex', justifyContent: 'center', mx: { md: '60px', sm: '12px', xs: "12px" }, mb: '60px', flexWrap: 'wrap' }}>
        {alphabets.map((a) => (
          <Link
            underline="none"
            key={getRandomStr(3)}
            variant="button"
            sx={{
              cursor: 'pointer', color: a.toLowerCase() === alphabet ? '#fff' : '#6e6e73', border: '1px solid', borderColor: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              fontWeight: a.toLowerCase() === alphabet ? 600 : 500, background: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              px: 1, py: .2, borderRadius: '8px', mr: 1,
              '&:hover': { borderColor: 'rgba(0, 0, 0, 0.12)' }
            }}
            // onClick={() => handleAlphabetClick(a)}
            href={`/browse/stocks/${a.toLowerCase()}`}
          >
            {a}
          </Link>
        ))}
      </Box>
    </>
  );
};

// const StockListWithQueryProvider = (props) => (
//   <QueryClientProvider client={queryClient}>
//     <StockList {...props} />
//   </QueryClientProvider>
// );

export default StockList;


// import React, { useState } from 'react';
// import { useQuery, QueryClientProvider } from 'react-query';
// import { FixedSizeList } from 'react-window'; // Change import here
// import TextField from '@mui/material/TextField';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemText from '@mui/material/ListItemText';
// import Typography from '@mui/material/Typography';
// import { queryClient } from '../../utils/queryClient';

// const getAlphabets = () => {
//   const alphabets = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));
//   return ['All', ...alphabets];
// };

// const filterStocksByAlphabet = (stocks, selectedAlphabet) => {
//   if (selectedAlphabet === 'All') {
//     return stocks;
//   }
//   return stocks.filter((stock) => stock.t.startsWith(selectedAlphabet));
// };

// const filterStocksBySearch = (stocks, searchQuery) => {
//   if (!searchQuery) {
//     return stocks;
//   }
//   const query = searchQuery.toLowerCase();
//   return stocks.filter((stock) => stock.t.toLowerCase().includes(query) || stock.n1.toLowerCase().includes(query));
// };

// const StockList = ({ stockData }) => {
//   const [selectedAlphabet, setSelectedAlphabet] = useState('All');
//   const [searchQuery, setSearchQuery] = useState('');
//   const { data: filteredStocks } = useQuery(['stocks', selectedAlphabet, searchQuery], () => {
//     let result = filterStocksByAlphabet(stockData, selectedAlphabet);
//     result = filterStocksBySearch(result, searchQuery);
//     return result;
//   });

//   const alphabets = getAlphabets();

//   const handleAlphabetClick = (alphabet) => {
//     setSelectedAlphabet(alphabet);
//   };

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleListItemClick = (ticker) => {
//     // Navigate to "/stock/ticker" on item click
//     // You can use Next.js Link or router.push for navigation
//     console.log(`Navigating to /stock/${ticker}`);
//   };

//   const renderStockItem = ({ index, style }) => {
//     const stock = filteredStocks[index];

//     if (!stock) {
//       return null;
//     }

//     return (
//       <ListItem key={stock.t} onClick={() => handleListItemClick(stock.t)} style={style}>
//         <ListItemText primary={stock.t} secondary={stock.n1} />
//       </ListItem>
//     );
//   };

//   return (
//     <div style={{ overflowX: 'hidden' }}>
//       <TextField
//         label="Search"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         value={searchQuery}
//         onChange={handleSearchChange}
//       />

//       <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
//         {alphabets.map((alphabet) => (
//           <Typography
//             key={alphabet}
//             variant="button"
//             style={{ cursor: 'pointer', color: alphabet === selectedAlphabet ? 'blue' : 'inherit' }}
//             onClick={() => handleAlphabetClick(alphabet)}
//           >
//             {alphabet}
//           </Typography>
//         ))}
//       </div>

//       <List dense={true}>
//         <FixedSizeList
//           height={400}
//           itemCount={filteredStocks?.length || 0}
//           itemSize={60}
//           width={300}
//         >
//           {renderStockItem}
//         </FixedSizeList>
//       </List>
//     </div>
//   );
// };

// const StockListWithQueryProvider = (props) => (
//   <QueryClientProvider client={queryClient}>
//     <StockList {...props} />
//   </QueryClientProvider>
// );

// export default StockListWithQueryProvider;
